import SportOnboarding from "./components/SportOnboarding";
import { triathlonConfig } from "./ch/sportConfig";

const Triathlon = () => {
  return <SportOnboarding sportConfig={triathlonConfig} navKey="triathlon" />;
};

export default Triathlon;
